import React from "react";
import { Container } from "reactstrap";

export default function PrivacySection() {
    return (
        <Container className="termsconditions-container terms-content">
            {/* Overview */}
            <section id="overview" className="mb-5 terms-section">
                <h2 className="text-primary">Overview</h2>
                <p>
                    At Midamas LLP, we respect your privacy and are committed to protecting your personal information.
                    This Privacy Policy explains how we collect, use, and safeguard your data when you visit our Website{' '}
                    <a href="https://midamasjewellery.net" target="_blank" rel="noopener noreferrer">
                        midamasjewellery.net
                    </a>.
                </p>
               
                <hr style={{ width: "100%", borderTop: "2px solid #ccc", marginTop: "1rem" }} />
            </section>

            {/* Section 1 */}
            <section id="online-store-terms" className="mb-5 terms-section">
                <h2 className="text-primary">1. Information We Collect</h2>
                <p><strong>Contact Information: </strong>Name, email, phone number, company name (when you fill forms or contact us).</p>
                <p><strong>Technical Data: </strong>IP address, browser type, device type (for analytics).</p>
                <p><strong>Business Data:  </strong>If you are a retailer, we may collect GST, PAN, or business registration details when onboarding you as a client.</p>
            </section>

            {/* Section 2 */}
            <section id="general-conditions" className="mb-5 terms-section">
                <h2 className="text-primary">2. How We Use Your Information</h2>
                <p>To respond to enquiries and provide information about our jewellery collections.</p>
                <p>To improve our Website and user experience.</p>
                <p>To comply with legal and regulatory requirements.</p>    
            </section>

            {/* Section 3 */}
            <section id="accuracy-information" className="mb-5 terms-section">
                <h2 className="text-primary">3. Data Sharing</h2>
                <p>We do not sell, rent, or trade your personal information.</p>
                <p>Data may be shared only with trusted partners (IT providers, payment gateways, logistics partners) necessary for business operations.</p>
            </section>

            {/* Section 4 */}
            <section id="modifications-prices" className="mb-5 terms-section">
                <h2 className="text-primary">4. Data Security</h2>
                <p>Our Website is SSL secured (https://) to protect your information.</p>
                <p>We use reasonable measures to safeguard personal data, but no method of transmission over the Internet is 100% secure.</p>
            </section>

            {/* Section 5 */}
            <section id="products-services" className="mb-5 terms-section">
                <h2 className="text-primary">5. Your Rights</h2>
                <p>You may request access, correction, or deletion of your personal information by contacting us.</p>
                <p>You may choose not to participate or marketing communications at any time.</p>
            </section>

            {/* Section 6 */}
            <section id="billing-account" className="mb-5 terms-section">
                <h2 className="text-primary">6. Cookies</h2>
                <p>Our Website may use cookies to enhance browsing. You can disable cookies via your browser settings.</p>
            </section>

            {/* Section 7 */}
            <section id="optional-tools" className="mb-5 terms-section">
                <h2 className="text-primary">7. Changes to This Policy</h2>
                <p>We may update this Privacy Policy from time to time. Changes will be posted on this page.</p>
            </section>

            {/* Section 8 */}
            <section id="third-party-links" className="mb-5 terms-section">
                <h2 className="text-primary">8. Contact Us</h2>
                <p>If you have any questions regarding these Terms & Conditions or Privacy Policy, please contact us at:
                    Midamas LLP
                </p>
            </section>

        </Container>
    );
}
